export const defaultClientTemplateId = "custom-XSO6C";

export const noTemplateId = "default-XSO6C";

export const blogTemplateId = "blog-TeHqM";

export const isNoTemplate = (id: string) => {
  return id === noTemplateId;
};
